<loader-modal *ngIf="isLoading$ | async"></loader-modal>

<div class="page-container folder-overview">
  <ng-container *ngIf="folder$ | async as folder">
    <div class="flex page-sub-container overview-header">
      <div class="flex justify-between">
        <name-editor
          icon="folder"
          [name]="folder.name"
          [privilege]="Privilege.SOW__EDIT"
          (nameChanged)="updateFolder({ name: $event })"></name-editor>

        <div class="overview-header-status">
          <div class="font-newJuneBold">
            <div
              class="text-xl mb-2"
              [class]="getStatusClass(folder.status)">
              {{ folder.getStatusText() }}
            </div>
            <div class="text-xs"><span>Created by:</span> {{ folder.createdBy?.getFullname() }}</div>
          </div>

          <div class="font-newJuneBold">
            <div class="text-xl mb-2">
              <span class="primary-blue-violet"> F-{{ folder.identity?.localId }} </span>
            </div>
            <div class="text-xs"><span>Date created:</span> {{ folder.createdTs | dateFormat: 'shortDate' }}</div>
          </div>
        </div>
      </div>

      <div class="overview-header-description">
        <description-editor
          status="DRAFT"
          [(visible)]="isEditDescription"
          [model]="folder"
          [editable]="hasEditPrivilege"
          (onSaveDescription)="updateFolder({ description: $event })"
          (onSaveNote)="updateFolder({ internalNote: $event })" />
      </div>
    </div>

    <div class="page-sub-container mt-2"><mat-divider /></div>

    <div class="page-sub-container">
      <div class="text-xs">
        <div class="flex flex-row items-center justify-between">
          <div class="flex flex-row items-center">
            <span class="detail-field">
              <span class="title">{{ 'second_party' | lang }}:</span>
              <span class="data">{{ folder.identity?.secondParty?.name || '--' }}</span>
            </span>
            <span class="detail-field">
              <span class="title">Office:</span>
              <span class="data">{{ folder.identity?.officeLocation?.name || '--' }}</span>
            </span>
            <span class="detail-field">
              <span class="title">{{ 'brand' | lang }}:</span>
              <span class="data">{{ folder.identity?.brand?.name || '--' }}</span>
            </span>
            <span class="detail-field">
              <span class="title">Version:</span>
              <span class="data">
                <scope-ui-dropdown
                  dropdownClass="small-dropdown"
                  [selectedValue]="selectedVersion"
                  [dropdownOptions]="versionNumbers"
                  [isStandardDropdown]="true"
                  [displayFn]="versionDisplayFn"
                  (onSelectionChange)="changeVersion($event)">
                </scope-ui-dropdown>
              </span>
            </span>
            <span class="detail-field">
              <span class="title">Start date:</span>
              <span class="data">{{ (folder?.startDate | dateFormat: 'shortDate') || '--' }}</span>
            </span>
            <span class="detail-field">
              <span class="title">End date:</span>
              <span class="data">{{ (folder?.endDate | dateFormat: 'shortDate') || '--' }}</span>
            </span>
            <span class="detail-field">
              <span class="title">Key Contact:</span>
              <span class="data">{{ folder.identity?.secondPartyContact?.contactName || '--' }}</span>
            </span>
          </div>
          <a
            class="view_more orange font-newJuneBold"
            (click)="isDetailsExpanded = !isDetailsExpanded">
            {{ isDetailsExpanded ? 'View less' : 'View more' }}
          </a>
        </div>
        <div
          class="flex flex-row items-center"
          *ngIf="isDetailsExpanded">
          <span class="detail-field">
            <span class="title">Location:</span>
            <span class="data">{{ folder.identity?.location?.location || '--' }}</span>
          </span>
          <ng-container *ngIf="retainedHoursStats$ | async as retainedHoursStats">
            <span class="detail-field">
              <span class="title">
                <mat-icon
                  class="material-symbols-rounded"
                  isEllipsisActive="Hours used are estimations only until the {{ 'scope' | lang }} is approved">
                  info
                </mat-icon>
                Retained Hours Used:
              </span>
              <span class="data">{{ retainedHoursStats.usedHours | formatHours }}</span>
            </span>
            <span class="detail-field">
              <span class="title">Retained Hours Remaining:</span>
              <span class="data">{{ retainedHoursStats.remainingHours | formatHours }}</span>
            </span>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="page-sub-container"><mat-divider /></div>

    <div class="page-sub-container">
      <scope-ui-tabs
        fontSize="14px"
        class="pt-4 scope-tabs"
        (onSelect)="selectTab($event)"
        (onInit)="selectTab(getActiveRouteTab())">
        <scope-ui-tab
          tabTitle="{{ 'sow' | lang }}"
          [routeLink]="FolderOverviewTab.FOLDER"
          [active]="isActiveTab()">
          <folder-overview-folder-container></folder-overview-folder-container>
        </scope-ui-tab>
        <scope-ui-tab
          tabTitle="Activity"
          [routeLink]="FolderOverviewTab.ACTIVITY"
          [active]="isActiveTab(FolderOverviewTab.ACTIVITY)">
          <folder-overview-activity></folder-overview-activity>
        </scope-ui-tab>
        <scope-ui-tab
          tabTitle="Details"
          [routeLink]="FolderOverviewTab.DETAILS"
          [active]="isActiveTab(FolderOverviewTab.DETAILS)">
          <folder-overview-details></folder-overview-details>
        </scope-ui-tab>
        <scope-ui-tab
          tabTitle="Retained Teams"
          [routeLink]="FolderOverviewTab.RETAINED_TEAMS"
          [active]="isActiveTab(FolderOverviewTab.RETAINED_TEAMS)">
          <folder-overview-retained-teams></folder-overview-retained-teams>
        </scope-ui-tab>
        <scope-ui-tab
          tabTitle="Retainer Breakdown"
          [routeLink]="FolderOverviewTab.RETAINER_BREAKDOWN"
          [active]="isActiveTab(FolderOverviewTab.RETAINER_BREAKDOWN)">
          <folder-overview-retainer-breakdown></folder-overview-retainer-breakdown>
        </scope-ui-tab>
      </scope-ui-tabs>
    </div>
  </ng-container>
</div>

<folder-overview-footer [folder]="folder$ | async"></folder-overview-footer>
